import script from "./CampoBuscaMultiplo.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoBuscaMultiplo.vue?vue&type=script&setup=true&lang=js"

import "./CampoBuscaMultiplo.vue?vue&type=style&index=0&id=959a82ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-959a82ea"]])

export default __exports__